import { z } from "zod";
import { GameEventV0 } from "./events";

/**
 * SaveV0 (F0-T15, stack §3.2): el event log ES el save — cargar una partida es
 * replay (reduce). El layout de ventanas y las posiciones del corcho son UI,
 * viajan al lado del log. Export/import usa exactamente esta forma (C4:
 * playtest remoto = el tester manda este JSON).
 */

export const CardPosV0 = z.object({ x: z.number(), y: z.number() });

export const SaveV0 = z.object({
  saveVersion: z.literal("0.1.0"),
  caseId: z.string().min(1),
  detectiveName: z.string().optional(),
  events: z.array(GameEventV0),
  /** Forma serializada del windowStore (getLayout) — opaca para el schema */
  windowLayout: z.unknown().optional(),
  corchoPositions: z.record(z.string(), CardPosV0).default({}),
  createdAt: z.number(),
  updatedAt: z.number(),
  /** Metadatos de sesión para telemetría (D-14) */
  sessionMeta: z.object({ exportedAt: z.number(), userAgent: z.string() }).optional(),
});

export type SaveV0Data = z.infer<typeof SaveV0>;
